<template>
  <a :href="item.link" :target="target">
    <div class="dea-live-card" :class="cardModifierClass">
      <div class="dea-live-card__image-container">
        <div class="dea-live-card__image">
          <img :src="item.image" :alt="item.title" />
        </div>
        <div class="dea-live-card__image-badge-container">
          <div class="dea-live-card__text">
            <Badge
              v-for="(category, index) in item.categories"
              :key="index"
              class="dea-badge--dealive"
              :class="badgeModifierClass"
              >{{ category.name }}</Badge
            >
          </div>
        </div>
      </div>
      <div class="dea-live-card__content-container">
        <div class="dea-live-card__content">
          <h2 class="dea-live-card__title">{{ item.title }}</h2>
          <div class="dea-live-card__content-info">
            <p class="dea-live-card__text dea-live-card__text-date">{{ parseDate }}</p>
            <p class="dea-live-card__text dea-live-card__text-author">
              di
              <span v-for="(author, index) in item.authors" :key="index"
                ><template v-if="index > 0">, </template>{{ author }}</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import Badge from "../elements/Badge";

export default {
  name: "CardDeaLive",
  components: { Badge },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    target: {
      type: String,
      default: "_blank",
    },
    modifier: {
      type: String,
      default: "",
    },
  },
  computed: {
    parseDate() {
      const date = new Date(this.item.date);
      const dateString = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
      return dateString;
    },
    cardModifierClass() {
      if (this.modifier) {
        return `dea-live-card--${this.modifier}`;
      }
      return "";
    },
    badgeModifierClass() {
      if (this.modifier) {
        return `dea-badge--dealive-${this.modifier}`;
      }
      return "";
    },
  },
};
</script>

<style lang="scss"></style>
